import React from "react";
import FormCol from "../../../../../../common/Form/FormCol";
import FormGroup from "../../../../../../common/Form/FormGroup";
import FormRow from "../../../../../../common/Form/FormRow";

const ContactForm = () => {
  return (
    <form noValidate autoComplete="off">
      <FormGroup>
        <FormRow>
          <FormCol label="First Name" name="firstName" />

          <FormCol label="Last Name" name="lastName" />
        </FormRow>
      </FormGroup>

      <FormGroup>
        <FormRow>
          <FormCol label="Email Address" name="email" />
        </FormRow>
      </FormGroup>

      <FormGroup>
        <FormRow>
          <FormCol label="Subject" name="subject" />
        </FormRow>
      </FormGroup>

      <FormGroup>
        <FormRow>
          <FormCol type="textarea" label="Message" name="message" />
        </FormRow>
      </FormGroup>

      <FormGroup>
        <FormRow>
          <FormCol type="button" label="Send Message" btnPosition="right" />
        </FormRow>
      </FormGroup>
    </form>
  );
};

export default ContactForm;
